import React, { FC, useState, useEffect, useContext } from 'react';

import { SelectedIndexContext } from '../../App';
import { Course, Matches, TeamGameMatch } from '../../../database.schema';
import { useFetchTeamGameMatchAwaitingScores, TeamGameMatchAwaitingScores } from '../../api/hooks/use-fetch-results-awaiting-scores';
import { TeamGameMatchEntry } from './match-entry/team-games/team-game-match-entry';
import { ApplyTeamGameResults } from './result-entry/team-games/apply-team-game-results';

const initialMatches: Matches = {
  courseId: -1,
  format: 'Pairs',
  matches: [],
  startingHole: 1,
};

export const CreateTeamGameMatch: FC = (): JSX.Element => {
  const { selectedTournamentIndex } = useContext(SelectedIndexContext);
  const { data, isLoading, error } = useFetchTeamGameMatchAwaitingScores(selectedTournamentIndex);
  const [recordedMatch, setRecordedMatch] = useState<TeamGameMatch>();
  const [resultIndexStore, setResultIndexStore] = useState<number>(-1);
  const [nextMatchIndexStore, setNextMatchIndexStore] = useState<number>(-100);
  const [coursesStore, setCoursesStore] = useState<Array<Course>>([]);

  useEffect(() => {
    if (data) {
      const { resultIndex, match, nextMatchIndex, courses } = data as TeamGameMatchAwaitingScores;
      setRecordedMatch(match);
      setResultIndexStore(resultIndex);
      if (Number(nextMatchIndex) > -1) {
        setNextMatchIndexStore(Number(nextMatchIndex));
      }
      if (match) {
        setRecordedMatch({ ...match });
      }
      if (courses) {
        setCoursesStore(courses);
      }
    }
  }, [data]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error...</div>;
  }
  if (resultIndexStore > -1 && recordedMatch) {
    return <ApplyTeamGameResults match={recordedMatch} matchIndex={resultIndexStore} selectedTournamentIndex={selectedTournamentIndex} courses={coursesStore} />;
  }
  if (nextMatchIndexStore > -1) {
    return <TeamGameMatchEntry nextMatchIndex={nextMatchIndexStore} courses={coursesStore} />;
  }
  return <div>We seem to have a problem</div>;
};
